import { AxiosResponse } from "axios";
import { axiosInstance } from "src/services/axiosSetup";
import * as API_URL from "src/services/consts/contactUs/index"
import { IContractUsFromRequestBody } from "./modules";


export function submitContactUsFormsRequestApi(data: IContractUsFromRequestBody): Promise<any> {
    return axiosInstance.post(`${API_URL.URL_CONTACT_US_FORM_SUBMIT}`, { ...data }).then((d: AxiosResponse) => d.data);
}
